import { useState } from 'react';
import { StorageService, StorageItem } from '../../../services/storageService';

export const useHTMLViewer = () => {
  const [viewingFile, setViewingFile] = useState<{ url: string; fileName: string } | null>(null);
  const [loadingFileUrl, setLoadingFileUrl] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const handleHTMLFileClick = async (item: StorageItem) => {
    if (item.name.toLowerCase().endsWith('.html')) {
      try {
        setLoadingFileUrl(true);
        setError(null);
        const url = await StorageService.getFileURL(item.path);
        setViewingFile({
          url,
          fileName: item.name
        });
      } catch (error) {
        setError('Failed to open the file. Please try again.');
      } finally {
        setLoadingFileUrl(false);
      }
    }
  };

  const closeHTMLViewer = () => {
    setViewingFile(null);
  };

  const handleItemClick = (item: StorageItem, onNavigateToFolder: (path: string) => void) => {
    if (item.type === 'folder') {
      onNavigateToFolder(item.path);
    } else {
      handleHTMLFileClick(item);
    }
  };

  return {
    viewingFile,
    loadingFileUrl,
    error,
    handleHTMLFileClick,
    handleItemClick,
    closeHTMLViewer,
    setError
  };
};
